import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../service/login.service';
import Swal from 'sweetalert2';
import { BaseResponse } from 'src/app/shared/models/base-api-response.interface';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  public show: boolean = false;
  public numeroDocumento: number;
  public codigo: number;
  password: string = '';
  newPassword: string = '';
  mostrarTabla: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: LoginService
  ) { }

  ngOnInit() {
    const doc = this.route.snapshot.paramMap.get('doc');
    this.numeroDocumento = parseInt(doc, 10);
  }

  showPassword() {
    this.show = !this.show;
  }

  onInputChange(event: any): void {
    const input = event.target.value;
    event.target.value = input.replace(/[^0-9]/g, '');
  }

  resetPassword() {
    if (!this.codigo || this.codigo === undefined) {
      Swal.fire({
        title: "Campo requerido",
        text: "Ingresá el código enviado a tu correo electrónico",
        icon: "error",
        confirmButtonText: "Aceptar"
      });
      return;
    }

    this.authService.verificarCodigo(this.numeroDocumento, this.codigo).subscribe({
      next: async (data: BaseResponse) => {
        if (data.isSuccess) {
          this.mostrarTabla = false;
        } else {
          Swal.fire({
            title: "Verificación de código",
            text: data.message,
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  changePassword() {
    if (!this.password || this.password.trim() === '') {
      Swal.fire({
        title: "Campo requerido",
        text: "Debe ingresar su nueva contraseña",
        icon: "error",
        confirmButtonText: "Aceptar"
      });
      return;
    }

    if (!this.newPassword || this.newPassword.trim() === '') {
      Swal.fire({
        title: "Campo requerido",
        text: "Debe repetir la contraseña",
        icon: "error",
        confirmButtonText: "Aceptar"
      });
      return;
    }

    if (this.newPassword !== this.password) {
      Swal.fire({
        title: "No coinciden",
        text: "Las contraseñas ingresadas no coinciden",
        icon: "error",
        confirmButtonText: "Aceptar"
      });
    } else {
      this.authService.changePassword(this.numeroDocumento, this.password).subscribe({
        next: async (data: BaseResponse) => {
          if (data.isSuccess) {
            Swal.fire({
              title: "Operación exitosa",
              text: data.message,
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.router.navigateByUrl("login");
          } else {
            Swal.fire({
              title: "Operación fallida",
              text: data.message,
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        },
        error: (error) => {
          console.error(error);
        }
      })
    }
  }

}